import { ory } from '@/lib'

const state = () => ({
  token: undefined,
})

const getters = {
  authorization: (state) => {
    if (!state.token) return undefined
    return `Bearer ${state.token}`
  },
  token: (state) => state.token,
}

const actions = {
  async authenticate({ commit, state }) {
    try {
      const data = await ory.toSession({ tokenizeAs: 'jwt_default' })

      if (!data?.identity?.metadata_public?.metapic_user_id) return null

      commit('setToken', { token: data.tokenized })
    } catch (e) {
      commit('setToken', { token: undefined })
      return false
    }

    return !!state.token
  },
  async refreshToken({ dispatch, state }) {
    await dispatch('authenticate')
    return state.token
  },
  async logout() {
    try {
      const data = await ory.createBrowserLogoutFlow({ returnTo: window.location.origin })
      return data.logout_url
    } catch (e) {
      return null
    }
  },
}

const mutations = {
  setToken(state, { token }) {
    state.token = token
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
